let env = process.env.REACT_APP_ENV; //環境變數
let ApiServer, StaticServer, MMBUrl, IBEUrl;

switch (env) {
	case 'production':
		ApiServer = 'https://itapi-08.tigerairtw.com';
		StaticServer = 'https://static.tigerairtw.com';
		MMBUrl = 'https://manage-ttw.tigerairtw.com';
		IBEUrl = 'https://bookings-ttw.tigerairtw.com';
		break;
	case 'uat':
		ApiServer = 'https://test-proxy.tigerairtw.com/apis/b2b-uat';
		StaticServer = 'https://test-static.tigerairtw.com';
		MMBUrl = 'https://test-manage-ttw.tigerairtw.com';
		IBEUrl = 'https://test-bookings-ttw.tigerairtw.com';
		break;
	case 'development':
	default:
		ApiServer = 'https://test-proxy.tigerairtw.com/apis/b2b-sit';
		StaticServer = 'https://test-static.tigerairtw.com';
		MMBUrl = 'https://test-manage-ttw.tigerairtw.com';
		IBEUrl = 'https://test-bookings-ttw.tigerairtw.com';
		break;
}

const Rest = {
	apiServer: ApiServer,
	agent: {
		getAgent: (agentId) => { // 取得 Agent 資料
			return `${ApiServer}/v1/Agent${agentId ? `?agentId=${agentId}` : ''}`;
		},
		postAgent: () => {  // 搜尋 Agent 資料
			return `${ApiServer}/v1/Agent`;
		},
		putAgent: (agentId) => { // 編輯子帳號
			return `${ApiServer}/v1/Agent${agentId ? `?agentId=${agentId}` : ''}`;
		},
		postSubAgent: () => { // 新增子帳號
			return `${ApiServer}/v1/Agent/subagent`;
		},
		postMainAgent: () => { // 註冊主帳號
			return `${ApiServer}/v1/Agent/mainagent`;
		},
		putMainAgent: () => { // 編輯主帳號
			return `${ApiServer}/v1/Agent/mainagent`;
		},
		postRole: () => { // 取得 RoleList 資料
			return `${ApiServer}/v1/Agent/role`;
		},
		getAllAgent: () => { // 取得取得此帳號底下的所有 Agent
			return `${ApiServer}/v1/Agent/all`;
		},
	},
	booking: {
		getBooking: (type, data) => { // 取得訂單資料
			switch (type) {
				case 'id':
					return `${ApiServer}/v1/Booking/${data}`;
				case 'recordLocator':
					return `${ApiServer}/v1/Booking${data ? `?recordLocator=${data}` : ''}`;
				default:
					break;
			}
		},
		postBooking: () => { // 搜尋訂單
			return `${ApiServer}/v1/Booking`;
		},
		getBookingPDF: (pnr, locale) => { // 匯出 PDF
			return `${ApiServer}/v1/Booking/pdf/${pnr}${locale ? `?locale=${locale}` : ''}`;
		}
	},
	common: {
		getErrorCodes: () => { // 取得錯誤代碼
			return `${ApiServer}/v1/Common/errorcodes`;
		},
		getHeaders: () => { // 取得 Header
			return `${ApiServer}/v1/Common/headers`;
		}
	},
	organization: {
		getAccountBalance: () => { // 取得帳戶餘額
			return `${ApiServer}/v1/Organization/accountBalance`;
		}
	},
	report: {
		getAccountBalance: (params) => { // 匯出對帳單
			return `${ApiServer}/v1/Report/accountBalance${params.start ? `?start=${params.start}` : ''}${params.end ? `&end=${params.end}` : ''}${params.pageIndex ? `&pageIndex=${params.pageIndex}` : ''}${params.pageSize ? `&pageSize=${params.pageSize}` : ''}`;
		},
		getAccountBalancePDF: (params) => { // 匯出對帳單PDF
			return `${ApiServer}/v1/Report/accountBalance/file${params.start ? `?start=${params.start}` : ''}${params.end ? `&end=${params.end}` : ''}`;
		},
	},
	session: {
		postSession: () => { // 登入
			return `${ApiServer}/v1/Session`;
		},
		deleteSession: () => { // 登出
			return `${ApiServer}/v1/Session`;
		},
		postPortal: (pnr) => { // 取得導至其它平台的 token 如 IBE/MMB
			return `${ApiServer}/v1/Session/portal${pnr ? `?pnr=${pnr}` : ''}`;
		},
		postMima: () => { // 忘記密碼
			return `${ApiServer}/v1/Session/mima`;
		},
		putMima: () => { // 重設密碼
			return `${ApiServer}/v1/Session/mima`;
		},
	},
	static: {
		getTranslation: (locale) => { // 取得翻譯資料JSON
			return `${StaticServer}/ibe/translation/${locale}.json`;
		},
		getB2BAppSettings: () => { // 取得靜態設定資料
			return `${StaticServer}/ibe/b2b-appsettings.json`;
		}
	},
	directUrl: {
		MMBUrl,
		IBEUrl
	}
};

export default Rest;